import React from "react";
import { Row, Col } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import { useAppUser } from "../../../../../../../../contexts/user-context/UserContext";
import CustomMenu from "../../../../../../../../shared/components/CustomMenu/CustomMenu";
import { DashboardMentoringPages } from "../../../../../../../mentoring/containers/Mentoring";
import MentoringSideBarHeader from "../components/header/MentoringSideBarHeader";

const MentoringMenuItems = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const appUser = useAppUser();

  return (
    <>
      <Row>
        <Col xs={12}>
          <MentoringSideBarHeader />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {appUser.userRole.isModerator ? (
            <CustomMenu
              data={[
                {
                  onClick: () => {
                    console.log("xxxxxxxxxxxxxxxxx");
                    history.push(DashboardMentoringPages.MENTOR_PROFILES);
                  },
                  text: "Mentor Profiles",
                  isActive:
                    pathname === DashboardMentoringPages.MENTOR_PROFILES,
                },
                {
                  onClick: () => {
                    history.push(
                      DashboardMentoringPages.MENTORING_SESSION_REQUESTS
                    );
                  },
                  text: "Session Requests",
                  isActive:
                    pathname ===
                    DashboardMentoringPages.MENTORING_SESSION_REQUESTS,
                },
              ]}
            />
          ) : (
            <CustomMenu
              data={[
                {
                  onClick: () => {
                    history.push(DashboardMentoringPages.MENTOR_PROFILES);
                  },
                  text: "Mentor Profiles",
                  isActive:
                    pathname === DashboardMentoringPages.MENTOR_PROFILES,
                },
                {
                  onClick: () => {
                    history.push(DashboardMentoringPages.MENTORING_SESSIONS);
                  },
                  text: "Mentoring Sessions",
                  isActive:
                    pathname === DashboardMentoringPages.MENTORING_SESSIONS,
                },
              ]}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default MentoringMenuItems;
